import React from 'react';
import ScoreScreen from './Component/score'

const ScoreView = () => {
    return (<ScoreScreen />)
}
export default ScoreView;